import React from'react';import FormattedRichMessage from'../components/FormattedRichMessage/FormattedRichMessage.js';var shouldShowError = function shouldShowError(error, componentName) {
  var errorComponent = ((error === null || error === void 0 ? void 0 : error.component) || '').toUpperCase();
  var component = (componentName || '').toUpperCase();
  return error && component !== '' && component === errorComponent;
};
var filterErrorsForComponent = function filterErrorsForComponent(errors, errorFor) {
  return errors === null || errors === void 0 ? void 0 : errors.filter(function (error) {
    return shouldShowError(error, errorFor);
  });
};
var ciamErrorToMuxError = function ciamErrorToMuxError(error, errorValues) {
  if (!error || !error.message) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: error.message,
    values: errorValues
  });
};
var ciamErrorsToMuxErrors = function ciamErrorsToMuxErrors(errors, errorValues) {
  return errors.map(function (error) {
    return ciamErrorToMuxError(error, errorValues);
  });
};export{ciamErrorToMuxError,ciamErrorsToMuxErrors,filterErrorsForComponent,shouldShowError};